import React from 'react';

import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';
import LinkButton from '@core/components/linkbutton/LinkButton';

import StarIcon from 'assets/icons/star-rating.svg';
import PremiumBadge from 'assets/icons/premium-badge.svg';
import ArrowRightIcon from 'assets/icons/arrow-right.svg';

import classes from './MiniContentCard.module.scss';


const MiniContentCard = ({ content }) => {
    return (
        <div className={classes.wrapper}>
            <img src={content.image} alt={content.title} />
            <div className={classes.content}>
                <h5>{content.title}</h5>
                <div>
                    <div className='d-flex gap-2'>
                        <div className='d-flex align-items-center gap-1'>
                            <StarIcon /> <h6 className='m-0'>{content.rate_average}</h6>
                        </div>
                        {content?.is_free ?
                            (
                                <div className={classes['free-badge']}>Free</div>
                            ) : (
                                <div className='mb-1'>
                                    <PremiumBadge />
                                </div>
                            )
                        }
                    </div>

                    <p>
                        {content.short_introduction}
                    </p>
                    <div className='d-flex justify-content-between align-items-center'>
                        <ProficiencyBadge proficiency={content?.proficiency} isMini={true}/>
                        <LinkButton
                            kind="simple"
                            to={`/courses/${content.id}/${content.slug
                                }`}>
                            Details <ArrowRightIcon />
                        </LinkButton>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default MiniContentCard;